import { Box, Flex, Text } from "@chakra-ui/react";
import dynamic from "next/dynamic";
import { useDispatch } from "react-redux";
import { addToCart } from "../../redux/actions";
import { trackAddToCart } from "../../utils/analytics";
import { Button as ButtonComponent, FreeDeliveryOffer } from "../common";
import IsDoctor from "../permission/isDoctor";

const EmblaCarousel = dynamic(() => import("../../components/emblaCarousel"));

const ProductOverView = ({ actions, product, cartProductIds }) => {
  const dispatch = useDispatch();
  const { id, name, images, in_stock, doctor_price, regular_price, old_price } =
    product;

  const inCart = cartProductIds?.includes(id);

  return (
    <>
      <Flex width={{ base: "100%", lg: "48%" }}>
        <EmblaCarousel images={images} />
      </Flex>
      <Flex
        mt={{ base: 5, lg: 0 }}
        flexDirection="column"
        width={{ base: "100%", lg: "48%" }}
      >
        <Flex
          alignItems={{ base: "flex-start", sm: "center" }}
          justifyContent={{ base: "flex-start", sm: "flex-start" }}
          flexDirection={{ base: "column", sm: "row" }}
        >
          <Box flexDirection="row">
            <Text variant="productCardTitle">{name}</Text>
            {in_stock ? (
              <Text
                ml="3"
                fontSize="12"
                variant="priceText"
                borderColor="maroon"
              >
                Before GST discount: ₹{old_price}
              </Text>
            ) : (
              <Text
                ml="3"
                fontSize="12"
                variant="priceText"
                borderColor="maroon"
              >
                Out of stock
              </Text>
            )}
          </Box>

          {in_stock && <FreeDeliveryOffer />}
        </Flex>
        {/* <Box
          mt={3}
          width="100%"
          noOfLines={2}
          flexWrap="wrap"
          fontSize="16px"
          fontWeight="400"
          fontFamily="Lato"
          color="titleColor"
        >
          {parse(short_description)}
        </Box> */}
        <Flex
          mt={7}
          mb={4}
          width="100%"
          alignItems="center"
          flexDirection="row"
          justifyContent="flex-start"
        >
          <ButtonComponent
            px="20px"
            color={inCart ? "maroon" : "white"}
            backgroundColor={inCart ? "grey" : "maroon"}
            title={inCart ? "Added to cart" : "Add to cart"}
            handleClick={() => {
              trackAddToCart(product);
              if (!in_stock) {
                alert("Product is out of stock!");
              } else {
                dispatch(addToCart(product));
              }
            }}
          />
          {IsDoctor() ? (
            <>
              <Text
                as="s"
                ml="3"
                color="titleColor"
                variant="priceText"
                display={{ base: "none", sm: "block" }}
              >
                ₹{parseFloat(regular_price).toFixed(2)}
              </Text>
              <Text variant="priceText" ml={{ base: "10px", sm: "3px" }}>
                ₹{parseFloat(doctor_price).toFixed(2)}
              </Text>
            </>
          ) : (
            <Text ml="5px" variant="priceText">
              ₹{parseFloat(regular_price).toFixed(2)}
            </Text>
          )}
        </Flex>
        {/* <UnorderedList>
          {actions.map((action, index) => (
            <ListItem>
              <Text
                mb={2}
                key={action}
                width="100%"
                color="titleColor"
                variant="productCardDescription"
              >
                {action}
              </Text>
            </ListItem>
          ))}
        </UnorderedList> */}
      </Flex>
    </>
  );
};
export default ProductOverView;
